import {
  ItemTableConsts,
} from 'client/util/Constants';

const { groupAsidePanel, userAsidePanel } = ItemTableConsts.panelType;

export default {
  methods: {
    handleLdapUnselected(ids) {
      if (this.isLdapInListOfIds(ids)) {
        return;
      }

      if (this.isParentLdapBindingUser()) {
        this.reselectLdapAndOpenModal();
      } else if (this.inGroupAside()) {
        this.onLdapDirectoryUnselected();
      }
    },

    checkIfLdapDirectBindingWasRemoved(newValue, oldValue) {
      // The new value will be less than the old value when a previously
      // removed direct binding was restored. i.e. An item that was selected,
      // was unselected, and then re-selected. We only care about the case
      // where LDAP may have been unselected, so we exit here.
      if (newValue <= oldValue) {
        return;
      }

      this.handleLdapUnselected(this.previouslyDirectlyBoundItems);
    },

    checkIfLdapWasUnselected(newValue, oldValue) {
      // The new value will be greater than the old value when new items were
      // selected. We only care about the case where LDAP may have been
      // unselected, so we exit here.
      if (newValue >= oldValue) {
        return;
      }

      this.handleLdapUnselected(this.selectedItems);
    },

    selectLdap() {
      const { id } = this.getLdap();
      this.selectItem({ id });
    },

    reselectLdapAndOpenModal() {
      this.selectLdap();
      return this.openModal(this.modalTypes.ldapBindingUser);
    },

    handleUnbindLdapBindingUser() {
      const { id } = this.getLdap();
      this.setParentField({ key: 'ldap_binding_user', value: false });
      this.unselectItem({ id });
      this.closeModal(this.modalTypes.ldapBindingUser);
    },

    handleUnselectLockedDirectoryItem(id) {
      if (this.isLdapInListOfIds([id]) && this.isParentSambaServiceAccount()) {
        return this.openModal(this.modalTypes.unableToRemoveUser);
      }

      if (this.inUserAside() && this.isActiveDirectoryInListOfIds([id])) {
        return this.openModal(this.modalTypes.unableToRemoveActiveDirectory);
      }

      return this.handleUnselectLockedItem(id);
    },

    handleUnselectMultipleDirectoryLockedItems(ids) {
      if (this.isLdapInListOfIds(ids) && this.isParentSambaServiceAccount()) {
        this.$refs.itemTable.setLoadingOverlay(false);
        return this.openModal(this.modalTypes.unableToRemoveUser);
      }

      if (this.inUserAside() && this.isActiveDirectoryInListOfIds(ids)) {
        this.$refs.itemTable.setLoadingOverlay(false);
        return this.openModal(this.modalTypes.unableToRemoveActiveDirectory);
      }

      return this.handleUnselectMultipleLockedItems(ids);
    },

    inGroupAside() {
      return this.panelType === groupAsidePanel;
    },

    inUserAside() {
      return this.panelType === userAsidePanel;
    },

    isLdapInListOfIds(ids) {
      return this.items
        .filter(item => ids.indexOf(item.id) !== -1 && this.isLdap()(item))
        .length === 1;
    },

    isActiveDirectoryInListOfIds(ids) {
      return ids.some((id) => {
        const item = this.getItem()(id);
        return this.isActiveDirectory()(item) && this.isItemPreviouslySelected(id);
      });
    },

    isLdapSelected() {
      return this.isLdapInListOfIds(this.selectedItems);
    },

    isParentLdapBindingUser() {
      return !!(this.parent && this.parent.ldap_binding_user);
    },

    isParentSambaServiceAccount() {
      return !!(this.parent && this.parent.samba_service_user);
    },

    isDirectoryItemLocked(id) {
      const item = this.getItem()(id);

      if (this.isLdap()(item) && this.isParentSambaServiceAccount()) {
        return true;
      }

      if (this.inUserAside() && this.isActiveDirectoryInListOfIds([id])) {
        return true;
      }

      return this.isItemLocked(id);
    },

    openModal(modalType) {
      this.modalVisible[modalType] = true;
      return new Promise(() => {});
    },

    closeModal(modalType) {
      this.modalVisible[modalType] = false;
    },
  },
};
